






























































    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { store, StoreState } from "../../store";
    import VeeValidate from 'vee-validate';    
    import { mapState } from 'vuex';
    import VueElementLoading from "vue-element-loading";
    import { RotateSquare2 } from "vue-loading-spinner";
    import EditContact from '../contact/EditContact.vue';
    import QuickCall from '../../components/QuickCall.vue';


@Component({
    components: {RotateSquare2,VueElementLoading,EditContact  ,QuickCall},
    computed: {
    ...mapState({
        'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
        'show_quick_call_modal': (state: StoreState) => state.dashboard.show_quick_call_modal,
        'number_to_call': (state: StoreState) => state.dashboard.number_to_call,
        })
    },
    methods: {
    }
    })
export default class conactdetail extends Vue {
    data() {
    return {
        URLIMGPLUS_G:"/img/rose-blue.jpeg",
        AddContact:"/img/icons/add-contact-button.png",
        contact_status:'',
    } //as MySettingsData
        }
          quickCall(number) {
            this.$store.commit('QUICK_CALL', number);
            }
     
        formatPhoneNumber(phoneNumber: any) {
            if(typeof phoneNumber === "number") {
                phoneNumber = phoneNumber.toString();
            }
            //This regex is based off the format of phone numbers
            //as they are returned in the contact list by the Kazoo API.
            //Link: https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
            //If the Hellospoke database uses a different format will adjust
            //the pattern accordingly
            const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
            const matches = phoneNumber.match(re);
            if(matches === null) {
                    console.log("The phone number " + phoneNumber + " could not be parsed");
                return "";
            }
            return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
        }

        get fullName() {
             this.$data.contact_status='';
            if((this as any).selectedContact) {
                return `${((this as any).selectedContact as any).first_name} ${((this as any).selectedContact as any).last_name}`;
            }
            else {
                return '';
            }
        }
         get formattedMainNumber() {
            if((this as any).selectedContact && (this as any).selectedContact.numbers && (this as any).selectedContact.numbers.main && (this as any).selectedContact.numbers.main.length > 0) {
             return this.formatPhoneNumber(((this as any).selectedContact as any).numbers.main[0]);
            }
            else {
                return '';
            }
        }
         get formattedMobileNumber() {
            if((this as any).selectedContact && (this as any).selectedContact.numbers && (this as any).selectedContact.numbers.mobile && (this as any).selectedContact.numbers.mobile.number) {
                return this.formatPhoneNumber(((this as any).selectedContact as any).numbers.mobile.number);
            }
            else {
                return '';
            }
        }

        get access_status(){
          return (this as any).selectedContact.private ?'Private':'Public';
        }
        get addressLastLine() {
            if((this as any).selectedContact && ((this as any).selectedContact as any).address) {
                const city = (this as any).selectedContact.address.city ? (this as any).selectedContact.address.city : '';
                const state = (this as any).selectedContact.address.state ? (this as any).selectedContact.address.state : '';
                const zip = (this as any).selectedContact.address.zip ? (this as any).selectedContact.address.zip : '';
                if(city === '' && state === '') {
                    return `${zip}`;
                }
                else {    
                    return `${city}, ${state} ${zip}`;
                }
            }
            else {
                return null;
            }
        }

         Edit_contact()
        {
        this.$data.contact_status='edit_contact';
         if(((this as any).selectedContact as any).numbers.mobile.number!=''){
          var  Mobile;
            if((this as any).selectedContact && (this as any).selectedContact.numbers && (this as any).selectedContact.numbers.mobile && (this as any).selectedContact.numbers.mobile.number) {
                Mobile= this.formatPhoneNumber(((this as any).selectedContact as any).numbers.mobile.number);
            }
            else {Mobile='';}
         }
         else {Mobile='';}
        if(((this as any).selectedContact as any).numbers.main[0]!=''){
            var MainNumber;
            if((this as any).selectedContact && (this as any).selectedContact.numbers && (this as any).selectedContact.numbers.main && (this as any).selectedContact.numbers.main.length > 0) {
                    MainNumber= this.formatPhoneNumber(((this as any).selectedContact as any).numbers.main[0]);
            }
            else {  MainNumber='';     }
        }
      else {  MainNumber='';     }
        this.$data.EditForm={
            firstName   :  ((this as any).selectedContact as any).first_name ,
            lastName    :  ((this as any).selectedContact as any).last_name , 
            comyName    :  ((this as any).selectedContact as any).compny_name , 
            main        :  MainNumber,
            extension   :  ((this as any).selectedContact as any).extension,   
            mobile      :  Mobile,
            customerid  :  ((this as any).selectedContact as any).custermerid , 
            addline1    :  ((this as any).selectedContact as any).address.line1 ,  
            addline2    :  ((this as any).selectedContact as any).address.line2 , 
            city        :  ((this as any).selectedContact as any).address.city , 
            state       :  ((this as any).selectedContact as any).address.state , 
            zip         :  ((this as any).selectedContact as any).address.zip , 
            email       :  ((this as any).selectedContact as any).email[0] ,
            Id          :  (this as any).selectedContact.private?0:1,
            updatePublic :  (this as any).selectedContact.updatePublic
        }
        this.$store.commit("EDIT_CONTACT_UPDATE",true);
        this.$store.commit("SHOW_CONTACT_LIST", false);
        this.$store.commit("SHOW_CONTACT_DETAIL", false);
        this.$store.commit("SET_SELECTED_CONTACTS", this.$data.EditForm);
        (this.$refs.editform as any).clearError();
    }

     
}
